<template>
    <div>
        <loading :active.sync="loader.isLoading" :can-cancel="loader.canCancel" :is-full-page="loader.fullPage" :color="loader.color" :height="loader.height" :width="loader.width" :background-color="loader.backgroundColor" :loader="loader.loader"></loading>
        <div class="row" style="margin-top: 100px">
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="top-list-small-toolbar">
                    <div>
                        <h4 class="text-primary">Laporan Salesman</h4>
                        <div class="form-inline">
                          <div class="button-group">
                            <span><b>Company:</b> </span>
                            <select v-model="company_no" class="btn btn-sm btn-soft-outline-primary">
                              <option value="">-- All --</option>
                              <option v-for="c in companyList" :key="c.id" :value="c.company_no">{{ c.name }}</option>
                            </select>
                          </div>
                          <span><b>Salesman:</b></span>
                          <v-select :options="getUserSalesman" :reduce="salesman => salesman.meta.code" label="salesman" v-model="salesman_id" class="vsc-custom vsc-custom-inline"/>
                          <span><b>Date:</b></span>
                          <date-picker v-model="startDate" type="date" range placeholder="Select date range"></date-picker>
                          <!-- <button class="btn btn-sm btn-hard-primary pull-left dropdown-toggle" type="button" id="refresh" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                            <i class="fa fa-refresh" aria-hidden="true"></i> Refresh
                          </button>
                          <div class="dropdown-menu" aria-labelledby="refresh">
                            <a class="dropdown-item" href="javascript:void(0)" @click="refreshAll">Refresh</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="refreshAll2">Refresh v2</a>
                          </div> -->
                          <!-- <input type="search" placeholder="search..." class="form-control mr-1 input-search" v-model="searchQuery" /> -->
                          <button type="button" class="btn btn-sm btn-hard-primary waves-light waves-effect ml-2" @click="refreshAll2"><i class="fa fa-refresh" aria-hidden="true"></i> Refresh</button>
                          <button class="btn btn-warning btn-sm pull-left dropdown-toggle ml-2" type="button" id="print" data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">Action</button>
                          <div class="dropdown-menu" aria-labelledby="print">
                            <a class="dropdown-item" href="javascript:void(0)" @click="refreshAll">Refresh Old</a>
                            <!-- <a class="dropdown-item" href="javascript:void(0)" @click="refreshAll2">Refresh v2</a> -->
                            <a class="dropdown-item" href="javascript:void(0)" @click="lockKomisi">Lock Komisi</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('pdf')">PDF</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('komisi')">PDF Komisi</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel')">Excel</a>
                            <a class="dropdown-item" href="javascript:void(0)" @click="print('excel-komisi')">Excel Komisi</a>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-md-12">
                <div class="card">
                    <div class="card-body">
                      <div class="row">
                        <div class="col-md-12">
                          <ul class="nav nav-tabs nav-bordered">
                            <li class="nav-item"><a href="#salesman" data-toggle="tab" aria-expanded="false" class="nav-link active">Data</a></li>
                            <li class="nav-item"><a href="#sales" data-toggle="tab" aria-expanded="false" class="nav-link">Sales</a></li>
                            <li class="nav-item"><a href="#komisi" data-toggle="tab" aria-expanded="false" class="nav-link">Komisi</a></li>
                            <li class="nav-item"><a href="#komisi-payment" data-toggle="tab" aria-expanded="false" class="nav-link">Komisi Payment</a></li>
                            <li class="nav-item"><a href="#retur" data-toggle="tab" aria-expanded="false" class="nav-link">Retur</a></li>
                            <li class="nav-item"><a href="#komisi-payment-supervisor" data-toggle="tab" aria-expanded="false" class="nav-link">Komisi Payment Supervisor</a></li>
                          </ul>
                          <div class="tab-content">
                            <div class="tab-pane active" id="salesman">
                              <div class="row">
                                <div class="col-md-4">
                                  <h5>Omzet Penjualan All</h5>
                                  <dl class="row" v-for="o in omzetData" :key="o.id">
                                    <dt class="col-md-4">{{ o.name }}</dt>
                                    <dd class="col-md-4 text-right">{{ o.totalSales | currency }}</dd>
                                  </dl>
                                  <dl class="row">
                                    <dt class="col-md-4">Total</dt>
                                    <dd class="col-md-4 text-right">{{ totalOmzet | currency }}</dd>
                                  </dl>
                                </div>
                                <div class="col-md-4" v-if="company_no === 'C0001'">
                                  <h5>Omzet Penjualan PPN</h5>
                                  <dl class="row" v-for="o in omzetData" :key="o.id">
                                    <dt class="col-md-4">{{ o.name }}</dt>
                                    <dd class="col-md-4 text-right">{{ o.totalSalesPPN | currency }}</dd>
                                  </dl>
                                  <dl class="row">
                                    <dt class="col-md-4">Total</dt>
                                    <dd class="col-md-4 text-right">{{ totalOmzetPPN | currency }}</dd>
                                  </dl>
                                </div>
                                <div class="col-md-4" v-else-if="company_no === 'C0002'">
                                  <h5>Omzet Penjualan Non PPN</h5>
                                  <dl class="row" v-for="o in omzetData" :key="o.id">
                                    <dt class="col-md-4">{{ o.name }}</dt>
                                    <dd class="col-md-4 text-right">{{ o.totalSalesNonPPN | currency }}</dd>
                                  </dl>
                                  <dl class="row">
                                    <dt class="col-md-4">Total</dt>
                                    <dd class="col-md-4 text-right">{{ totalOmzetNonPPN | currency }}</dd>
                                  </dl>
                                </div>
                              </div>
                              <hr>
                              <div class="row">
                                <div class="col-md-12">
                                  <h5>Penerimaan Pembayaran</h5>
                                  <div class="table-responsive">
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                        <th>Payment Cash/Transfer</th>
                                        <th>Payment Giro</th>
                                        <th>Discount</th>
                                        <th>Round</th>
                                        <th>Total Payment</th>
                                        <th>Total Komisi</th>
                                        <th>Total Komisi Supervisor</th>
                                      </thead>
                                      <tbody>
                                        <tr>
                                          <td>{{ totalPaymentCashBank | currency }}</td>
                                          <td>{{ totalPaymentGiro | currency }}</td>
                                          <td>{{ (totalDiscount15 + totalDiscount1) | currency }}</td>
                                          <td>{{ (totalRound15 + totalRound1) | currency }}</td>
                                          <td>{{ totalPaymentAll | currency }}</td>
                                          <td>{{ totalKomisiDiscount1 + totalKomisiDiscount15 + totalKomisiDiscount05 | currency }}</td>
                                          <td>{{ totalKomisiSupervisorIn | currency }}</td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <hr>
                              <div class="row">
                                <div class="col-md-12">
                                  <h5>Retur Penjualan</h5>
                                  <div class="table-responsive">
                                    <table class="table table-item mb-0 table-sm table-striped table-hover">
                                      <thead>
                                        <th>Status</th>
                                        <th>Type</th>
                                        <th>Status</th>
                                        <th>Date</th>
                                        <th>Return No.</th>
                                        <th>Customer</th>
                                        <th>Product No.</th>
                                        <th>Qty</th>
                                        <th class="text-right">Amount</th>
                                        <th class="text-right">Subtotal</th>
                                        <th class="text-right">Discount</th>
                                        <th class="text-right">Tax</th>
                                        <th class="text-right">Denda</th>
                                        <th class="text-right">Total</th>
                                      </thead>
                                      <tbody>
                                        <tr v-for="r in dataRetur" :key="r.id">
                                          <td>{{ r.status }}</td>
                                          <td>{{ r.type }}</td>
                                          <td>
                                            <span v-if="r.category === 'others'" class="badge badge-success">Lain-lain</span>
                                            <span v-else-if="r.category === 'cancel'" class="badge badge-danger">Batal</span>
                                          </td>
                                          <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                          <td><b>{{ r.return_no }}</b></td>
                                          <td>{{ r.customer }}</td>
                                          <td><b>[{{ r.product_no}}]</b> {{ r.product }}</td>
                                          <td>{{ r.qty }}</td>
                                          <td class="text-right">{{ r.amount | currency }}</td>
                                          <td class="text-right">{{ r.subtotal | currency }}</td>
                                          <td class="text-right">{{ r.discount | currency }}</td>
                                          <td class="text-right">{{ r.tax | currency }}</td>
                                          <td class="text-right">{{ r.penalty_amount | currency }}</td>
                                          <td class="text-right">{{ r.total | currency }}</td>
                                        </tr>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b><i>Total Retur:</i></b></td>
                                          <td class="text-right"><b>{{ dataTotalRetur | currency }}</b></td>
                                        </tr>
                                        <tr>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td></td>
                                          <td class="text-right"><b><i>Total Denda:</i></b></td>
                                          <td class="text-right"><b>{{ dataTotalPenalty | currency }}</b></td>
                                        </tr>
                                      </tbody>
                                    </table>
                                  </div>
                                </div>
                              </div>
                              <hr>
                              <div class="row">
                                <div class="col-md-8 mx-auto">
                                  <dl class="row">
                                    <dt class="col-md-6"><h4><b>Komisi</b></h4></dt>
                                    <dd class="col-md-6 text-right"><h4>{{ totalKomisiDiscount1 + totalKomisiDiscount15 + totalKomisiDiscount05 + totalKomisiSupervisorIn | currency }}</h4></dd>

                                    <dt class="col-md-6"><h4><b>Tambahan Transport</b></h4></dt>
                                    <dd class="col-md-6 text-right"><h4>{{ komisiPlus | currency }}</h4></dd>

                                    <dt class="col-md-6"><h4><b>Total Denda</b></h4></dt>
                                    <dd class="col-md-6 text-right"><h4>({{ dataTotalPenalty | currency }})</h4></dd>

                                    <dt class="col-md-6"><h4><b>Total Komisi</b></h4></dt>
                                    <dd class="col-md-6 text-right">
                                      <h4>{{ totalKomisi | currency }}</h4>
                                    </dd>

                                    <dt class="col-md-6"><h4><b>Total Komisi Pembulatan</b></h4></dt>
                                    <dd class="col-md-6 text-right"><h4>{{ totalKomisiPembulatan | currency }}</h4></dd>
                                  </dl>
                                </div>
                              </div>
                            </div>
                            <div class="tab-pane" id="sales">
                              <div v-for="s in dataSales" :key="s.id">
                                <h5 class="text-center">{{ s.name }}</h5>
                                <div class="table-responsive">
                                  <table class="table table-item mb-0 table-sm table-hover table-striped">
                                    <thead>
                                      <th>Sale No.</th>
                                      <th>Date</th>
                                      <th>Due Date</th>
                                      <th>Customer</th>
                                      <th>Salesman</th>
                                      <th class="text-right">Subtotal</th>
                                      <th class="text-right">Discount</th>
                                      <th class="text-right">Tax</th>
                                      <th class="text-right">Total</th>
                                    </thead>
                                    <tbody>
                                      <tr v-for="d in s.sales" :key="d.id">
                                        <td>{{ d.sale_no }}</td>
                                        <td>{{ d.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ d.sale_due_date | dateFormat('DD/MM/YYYY') }}</td>
                                        <td>{{ d.customer }}</td>
                                        <td>{{ d.salesman }}</td>
                                        <td class="text-right">{{ d.subtotal | currency }}</td>
                                        <td class="text-right">{{ d.discount | currency }}</td>
                                        <td class="text-right">{{ d.tax | currency }}</td>
                                        <td class="text-right">{{ d.total | currency }}</td>
                                      </tr>
                                      <tr>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td></td>
                                        <td class="text-right"><b>{{ s.total_sales | currency }}</b></td>
                                      </tr>
                                    </tbody>
                                  </table>
                                </div>
                              </div>
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Salesman</th>
                                    <th class="text-right">Total</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="a in groupDataSales" :key="a.salesman_id">
                                      <td><b>[{{ a.salesman_id}}]</b> {{ a.salesman }}</td>
                                      <td class="text-right">{{ a.total | currency }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td class="text-right"><i>Total</i></td>
                                      <td class="text-right">{{ totalGroupDataSales | currency }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="komisi">
                              <div class="row">
                                <div class="col-md-12">
                                  <div class="alert alert-info" role="alert">
                                    <ul>
                                      <li><strong>Tunai dan Transfer</strong> dihitung mulai dari Tanggal <strong>Dibuat</strong></li>
                                      <li><strong>Giro</strong> dihitung mulai dari Tanggal <strong>Cair (finish date)</strong></li>
                                    </ul>
                                  </div>
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total Komisi 1.5%</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalKomisiDiscount15 | currency }}</span>
                                      </h3>
                                    </div>
                                    <!--end card-body-->
                                  </div>
                                  <!--end card-->
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total Komisi 1%</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalKomisiDiscount1 | currency }}</span>
                                      </h3>
                                    </div>
                                    <!--end card-body-->
                                  </div>
                                  <!--end card-->
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-info">Total Komisi 0.5%</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalKomisiDiscount05 | currency }}</span>
                                      </h3>
                                    </div>
                                    <!--end card-body-->
                                  </div>
                                  <!--end card-->
                                </div>
                              </div>
                              <div class="row">
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-success">Total Komisi</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalKomisiDiscount15 + totalKomisiDiscount1  + totalKomisiDiscount05 | currency }}</span>
                                      </h3>
                                    </div>
                                    <!--end card-body-->
                                  </div>
                                  <!--end card-->
                                </div>
                                <div class="col-md-3">
                                  <div class="card report-card">
                                    <div class="card-body">
                                      <div class="float-right">
                                        <i class="dripicons-user-group report-main-icon"></i>
                                      </div>
                                      <h5><span class="badge badge-warning">Total Discount</span></h5>
                                      <h3 class="my-3">
                                        <span>{{ totalDiscount1 + totalDiscount15 | currency }}</span>
                                      </h3>
                                    </div>
                                    <!--end card-body-->
                                  </div>
                                  <!--end card-->
                                </div>
                              </div>
                              <hr>
                              <div class="table-responsive">
                                <div class="text-center mt-5">
                                    <h5><b>Komisi 1.5%</b></h5>
                                </div>
                                <hr>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th class="text-right">Giro</th>
                                    <th class="text-right">Cash/Bank</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiIn15" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td class="text-right">{{ p.payment_giro | currency }}</td>
                                      <td class="text-right">{{ p.payment_cash_bank | currency }}</td>
                                      <td class="text-right">{{ p.payment_amount | currency }}</td>
                                      <td class="text-right">{{ p.commission_amount | currency }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                        <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                        <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                      </td>
                                      <td>{{ p.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <!-- <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiIn15 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiIn15 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiIn15 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalKomisiIn15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr> -->
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Giro:</td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiIn15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Cash/Bank:</td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiIn15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Discount:</td>
                                      <td class="text-right"><b>{{ totalDiscount15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Round:</td>
                                      <td class="text-right"><b>{{ totalRound15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Payment:</td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiIn15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <!-- <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Komisi:</td>
                                      <td class="text-right"><b>{{ totalKomisiIn15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr> -->
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Komisi</td>
                                      <td class="text-right"><b>{{ totalKomisiDiscount15 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                              <div class="table-responsive">
                                <div class="text-center mt-5">
                                  <h5><b>Komisi 1%</b></h5>
                                </div>
                                <hr>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th class="text-right">Giro</th>
                                    <th class="text-right">Cash/Bank</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiIn1" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td class="text-right">{{ p.payment_giro | currency }}</td>
                                      <td class="text-right">{{ p.payment_cash_bank | currency }}</td>
                                      <td class="text-right">{{ p.payment_amount | currency }}</td>
                                      <td class="text-right">{{ p.commission_amount | currency }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                        <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                        <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                      </td>
                                      <td>{{ p.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <!-- <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiIn1 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiIn1 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiIn1 | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalKomisiIn1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr> -->
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Giro:</td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiIn1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Cash/Bank:</td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiIn1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Round:</td>
                                      <td class="text-right"><b>{{ totalRound1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Discount:</td>
                                      <td class="text-right"><b>{{ totalDiscount1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Payment:</td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiIn1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Komisi:</td>
                                      <td class="text-right"><b>{{ totalKomisiDiscount1 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                              <div class="table-responsive">
                                <div class="text-center mt-5">
                                  <h5><b>Komisi 0.5%</b></h5>
                                </div>
                                <hr>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th class="text-right">Giro</th>
                                    <th class="text-right">Cash/Bank</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiIn05" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td class="text-right">{{ p.payment_giro | currency }}</td>
                                      <td class="text-right">{{ p.payment_cash_bank | currency }}</td>
                                      <td class="text-right">{{ p.payment_amount | currency }}</td>
                                      <td class="text-right">{{ p.commission_amount | currency }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                        <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                        <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                      </td>
                                      <td>{{ p.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Giro:</td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiIn05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Cash/Bank:</td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiIn05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Round:</td>
                                      <td class="text-right"><b>{{ totalRound05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Discount:</td>
                                      <td class="text-right"><b>{{ totalDiscount05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Payment:</td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiIn05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Komisi:</td>
                                      <td class="text-right"><b>{{ totalKomisiDiscount05 | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                              <div class="table-responsive">
                                <div class="text-center mt-5">
                                    <h5><b>Komisi Hangus</b></h5>
                                </div>
                                <hr>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th class="text-right">Giro</th>
                                    <th class="text-right">Cash/Bank</th>
                                    <th class="text-right">Payment</th>
                                    <th class="text-right">Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiOut" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td class="text-right">{{ p.payment_giro | currency }}</td>
                                      <td class="text-right">{{ p.payment_cash_bank | currency }}</td>
                                      <td class="text-right">{{ p.payment_amount | currency }}</td>
                                      <td class="text-right">{{ p.commission_amount | currency }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                        <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                        <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                      </td>
                                      <td>{{ p.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <!-- <tr>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td></td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiOut | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiOut | currency }}</b></td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiOut | currency }}</b></td>
                                      <td class="text-right"></td>
                                      <td></td>
                                      <td></td>
                                    </tr> -->
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Giro:</td>
                                      <td class="text-right"><b>{{ totalPaymentGiroKomisiOut | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Cash/Bank:</td>
                                      <td class="text-right"><b>{{ totalPaymentCashBankKomisiOut | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                    <tr>
                                      <td colspan="8"></td>
                                      <td class="text-right">Total Payment:</td>
                                      <td class="text-right"><b>{{ totalPaymentKomisiOut | currency }}</b></td>
                                      <td></td>
                                      <td></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="komisi-payment">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th>Giro</th>
                                    <th>Cash/Bank</th>
                                    <th>Payment Amount</th>
                                    <th>Komisi</th>
                                    <th>Type</th>
                                    <th>%</th>
                                    <th>Lock</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiPayment" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td>{{ p.payment_giro }}</td>
                                      <td>{{ p.payment_cash_bank }}</td>
                                      <td>{{ p.payment_amount | currency }}</td>
                                      <td>{{ p.commission_amount | currency }}</td>
                                      <td>
                                        <div v-if="p.commission_type.length > 0">
                                          <span v-for="(t, tidx) in p.commission_type" :key="tidx">
                                            <span class="badge badge-primary mr-1" v-if="t === 'salesman'">{{ t }}</span>
                                            <span class="badge badge-success mr-1" v-else-if="t === 'customer'">{{ t }}</span>
                                            <span class="badge badge-secondary mr-1" v-else>{{ t }}</span>
                                          </span>
                                        </div>
                                        <div v-else>
                                          <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                          <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                          <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                        </div>
                                      </td>
                                      <td>{{ p.commission_percentage }}</td>
                                      <td>
                                        <i class="fa fa-check" v-if="p.commission_lock === true" style="color: green;"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                </table>
                                <br>
                                <hr>
                                <h5>Payment Group: ({{ groupPayment.length }})</h5>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Group No</th>
                                    <th>Sale No.</th>
                                    <th class="text-center">Age</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Rounding</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Komisi %</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(i, index) in groupPayment" :key="index">
                                      <td>
                                        <span class="badge badge-success" v-if="i.status === 'in'">{{ i.status }}</span>
                                        <span class="badge badge-danger" v-else>{{ i.status }}</span>
                                      </td>
                                      <td><b>{{ i.group_no }}</b></td>
                                      <td>{{ i.sale_no }}</td>
                                      <td class="text-center">{{ i.age }}</td>
                                      <td class="text-right">{{ i.subtotal | currency }}</td>
                                      <td class="text-right">{{ i.discount | currency }}</td>
                                      <td class="text-right">{{ i.round | currency }}</td>
                                      <td class="text-right">{{ i.total | currency }}</td>
                                      <td class="text-right">{{ i.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="5"></td>
                                      <td class="text-right">{{ totalDiscountGroupPayment | currency }}</td>
                                      <td colspan="3"></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="retur">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-striped table-hover">
                                  <thead>
                                    <th>Status</th>
                                    <th>Date</th>
                                    <th>Return No.</th>
                                    <th>Product No.</th>
                                    <th>Qty</th>
                                    <th>Amount</th>
                                    <th>Subtotal</th>
                                    <th>Discount</th>
                                    <th>Tax</th>
                                    <th>Total</th>
                                    <th>Denda</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="r in dataRetur" :key="r.id">
                                      <td>{{ r.status }}</td>
                                      <td>{{ r.return_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td><b>{{ r.return_no }}</b></td>
                                      <td><b>[{{ r.product_no}}]</b> {{ r.product }}</td>
                                      <td>{{ r.qty }}</td>
                                      <td>{{ r.amount | currency }}</td>
                                      <td>{{ r.subtotal | currency }}</td>
                                      <td>{{ r.discount | currency }}</td>
                                      <td>{{ r.tax | currency }}</td>
                                      <td>{{ r.total | currency }}</td>
                                      <td>{{ r.penalty_amount | currency }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                            <div class="tab-pane" id="komisi-payment-supervisor">
                              <div class="table-responsive">
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Sale No.</th>
                                    <th>Sale Date</th>
                                    <th>Payment Date</th>
                                    <th>Age</th>
                                    <th>Customer</th>
                                    <th>Giro</th>
                                    <th>Cash/Bank</th>
                                    <th>Payment Amount</th>
                                    <th>Komisi Type</th>
                                    <th>Komisi Salesman</th>
                                    <th>% Salesman</th>
                                    <th>Komisi Supervisor</th>
                                    <th>% Supervisor</th>
                                    <th>Lock</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="p in dataKomisiSupervisorPayment" :key="p.id">
                                      <td>
                                        <span class="badge badge-danger" v-if="p.status === 'out'">{{ p.status }}</span>
                                        <span class="badge badge-success" v-else>{{ p.status }}</span>
                                      </td>
                                      <td>
                                        <span @click="showSaleNo(p.sale_no)" data-toggle="modal" data-target="#modalSalesByNo" data-backdrop="static" data-keyboard="false">
                                          {{ p.sale_no}}
                                        </span>
                                      </td>
                                      <td>{{ p.sale_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.payment_date | dateFormat('DD/MM/YYYY') }}</td>
                                      <td>{{ p.age }}</td>
                                      <td>{{ p.customer }}</td>
                                      <td>{{ p.payment_giro }}</td>
                                      <td>{{ p.payment_cash_bank }}</td>
                                      <td>{{ p.payment_amount | currency }}</td>
                                      <td>
                                        <span class="badge badge-primary" v-if="p.commission_type === 'salesman'">{{ p.commission_type }}</span>
                                        <span class="badge badge-success" v-else-if="p.commission_type === 'customer'">{{ p.commission_type }}</span>
                                        <span class="badge badge-secondary" v-else>{{ p.commission_type }}</span>
                                      </td>
                                      <td>{{ p.commission_amount | currency }}</td>
                                      <td>{{ p.commission_percentage }}</td>
                                      <td>{{ p.commission_supervisor_amount | currency }}</td>
                                      <td>{{ p.commission_supervisor_percentage }}</td>
                                      <td>
                                        <i class="fa fa-check" v-if="p.commission_lock === true" style="color: green;"></i>
                                      </td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="14" class="text-right"><b>Total Komisi</b></td>
                                      <td>{{ totalKomisiSupervisorIn | currency }}</td>
                                    </tr>
                                    <tr>
                                      <td colspan="14" class="text-right"><b>Total Hangus</b></td>
                                      <td>{{ totalKomisiSupervisorOut | currency }}</td>
                                    </tr>
                                  </tfoot>
                                </table>
                                <br>
                                <hr>
                                <h5>Payment Group: ({{ groupSupervisorPayment.length }})</h5>
                                <table class="table table-item mb-0 table-sm table-hover table-striped">
                                  <thead>
                                    <th>Status</th>
                                    <th>Group No</th>
                                    <th>Sale No.</th>
                                    <th class="text-center">Age</th>
                                    <th class="text-right">Subtotal</th>
                                    <th class="text-right">Discount</th>
                                    <th class="text-right">Rounding</th>
                                    <th class="text-right">Total</th>
                                    <th class="text-right">Komisi %</th>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(i, index) in groupPayment" :key="index">
                                      <td>
                                        <span class="badge badge-success" v-if="i.status === 'in'">{{ i.status }}</span>
                                        <span class="badge badge-danger" v-else>{{ i.status }}</span>
                                      </td>
                                      <td><b>{{ i.group_no }}</b></td>
                                      <td>{{ i.sale_no }}</td>
                                      <td class="text-center">{{ i.age }}</td>
                                      <td class="text-right">{{ i.subtotal | currency }}</td>
                                      <td class="text-right">{{ i.discount | currency }}</td>
                                      <td class="text-right">{{ i.round | currency }}</td>
                                      <td class="text-right">{{ i.total | currency }}</td>
                                      <td class="text-right">{{ i.commission_percentage }}</td>
                                    </tr>
                                  </tbody>
                                  <tfoot>
                                    <tr>
                                      <td colspan="5"></td>
                                      <td class="text-right">{{ totalDiscountGroupPayment | currency }}</td>
                                      <td colspan="3"></td>
                                    </tr>
                                  </tfoot>
                                </table>
                              </div>
                              <!-- <pre>{{ dataKomisiSupervisorPayment }}</pre> -->
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-body">
                <v-chart class="chart" :option="option" />
              </div>
            </div>
          </div>
        </div>
        <SaleModal />
    </div>
</template>

<script>
import axios from 'axios'
import { mapState } from 'vuex'
import Loading from 'vue-loading-overlay'
import 'vue-loading-overlay/dist/vue-loading.css'
import { reportUrl, saleCommissionUrl, reportTransactionUrl, salesUrl, report2Url, getHeader } from '@/config'
import DatePicker from 'vue2-datepicker'
import SaleModal from '@/components/sales/SaleModal.vue'
import { use } from 'echarts/core'
import { CanvasRenderer } from 'echarts/renderers'
import { PieChart } from 'echarts/charts'
import { TitleComponent, TooltipComponent, LegendComponent, GridComponent } from 'echarts/components'
import VChart, { THEME_KEY } from 'vue-echarts'

use([
  CanvasRenderer,
  PieChart,
  TitleComponent,
  TooltipComponent,
  LegendComponent,
  GridComponent
])

export default {
  name: 'SaleReportSalesman',
  props: ['scroll'],
  provide: { [THEME_KEY]: 'light' },
  components: {
    Loading,
    DatePicker,
    SaleModal,
    VChart
  },
  data () {
    var date = new Date()
    // var firstDay = new Date(date.getUrcFullYear(), date.getMonth(), 1)
    // var lastDay = new Date(date.getFullYear(), date.getMonth() + 1, 0)
    // const date1 = new Date(firstDay.getFullYear(), firstDay.getMonth(), firstDay.getDate())
    // const date2 = new Date(lastDay.getFullYear(), lastDay.getMonth(), lastDay.getDate())
    return {
      groupPayment: [],
      groupSupervisorPayment: [],
      option: {},
      dataKasProduksi: [],
      komisiPlus: 0,
      dataTotalRetur: 0,
      dataTotalPenalty: 0,
      dataRetur: [],
      dataSales: [],
      dataKomisi: [],
      dataKomisiSupervisor: [],
      dataKomisiPayment: [],
      dataKomisiSupervisorPayment: [],
      filterType: [],
      loadingSales: true,
      selected: [],
      startDate: [date, date],
      term: 0,
      salesman_id: '',
      company_no: '',
      year: '2022',
      date: null,
      typeData: null,
      period: [],
      dataRaw: [],
      loader: {
        isLoading: false,
        fullPage: true,
        color: '#007bff',
        canCancel: true,
        height: 128,
        width: 128,
        backgroundColor: '#ffffff',
        loader: 'spinner'
      },
      searchQuery: '',
      ascending: true,
      sortClick: false,
      sortColumn: '',
      pageSize: 100,
      currentPage: 1
    }
  },
  async mounted () {
    await this.$Progress.start()
    this.loader.isLoading = true
    await this.$store.dispatch('getCompanyList')
    await this.$store.dispatch('getEmployeeList')
    await this.$Progress.finish()
    this.loader.isLoading = false
  },
  computed: {
    ...mapState({
      rowsTable: state => state.data.rowsTable,
      companyList: state => state.companies.companyList,
      employeeList: state => state.employees.employeeList,
      authUser: state => state.users.authUser
    }),
    totalKomisiSupervisorIn () {
      const array = this.dataKomisiSupervisorPayment
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'in') {
          if (array[i].commission_supervisor_amount !== null) {
            sum += parseFloat(array[i].commission_supervisor_amount)
          }
        }
      }
      return sum
    },
    totalKomisiSupervisorOut () {
      const array = this.dataKomisiSupervisorPayment
      let sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          sum += parseFloat(array[i].commission_supervisor_amount)
        }
      }
      return sum
    },
    dataSalesRow () {
      var array = this.dataSales
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let a = 0; a < sales.length; a++) {
          loop.push(sales[a])
        }
      }
      return loop
    },
    groupDataSales () {
      var result = []
      if (this.dataSalesRow.length > 0) {
        this.dataSalesRow.reduce(function (res, value) {
          var key = value.salesman_id
          if (!res[key]) {
            res[key] = {
              salesman_id: value.salesman_id,
              salesman: value.salesman,
              total: parseFloat(value.total)
            }
            result.push(res[key])
          } else {
            res[key].total = parseFloat(res[key].total) + parseFloat(value.total)
          }
          return res
        }, {})
      }
      return result
    },
    totalGroupDataSales () {
      var array = this.groupDataSales
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalKomisiDiscount15 () {
      var sum = 0
      sum = this.totalPaymentKomisiIn15 * (1.5 / 100)
      return sum
    },
    totalKomisiDiscount1 () {
      var sum = 0
      sum = this.totalPaymentKomisiIn1 * (1 / 100)
      return sum
    },
    totalKomisiDiscount05 () {
      var sum = 0
      sum = this.totalPaymentKomisiIn05 * (0.5 / 100)
      return sum
    },
    totalDiscountGroupPayment () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].discount)
      }
      return sum
    },
    totalDiscount15 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 1.5) {
          sum += parseFloat(array[i].discount)
        }
      }
      return sum
    },
    totalRound15 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 1.5) {
          sum += parseFloat(array[i].round)
        }
      }
      return sum
    },
    totalDiscount1 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 1) {
          sum += parseFloat(array[i].discount)
        }
      }
      return sum
    },
    totalDiscount05 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 0.5) {
          sum += parseFloat(array[i].discount)
        }
      }
      return sum
    },
    totalRound1 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 1) {
          sum += parseFloat(array[i].round)
        }
      }
      return sum
    },
    totalRound05 () {
      var array = this.groupPayment
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (Number(array[i].commission_percentage) === 0.5) {
          sum += parseFloat(array[i].round)
        }
      }
      return sum
    },
    totalPaymentCashBank () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].payment_cash_bank)
      }
      return sum
    },
    totalPaymentGiro () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].payment_giro)
      }
      return sum
    },
    totalPaymentAll () {
      var sum = 0
      sum = this.totalPaymentCashBank + this.totalPaymentGiro - (this.totalDiscount15 + this.totalDiscount1) + this.totalRound1 + this.totalRound15
      return sum
    },
    totalPaymentGiroKomisiIn15 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1.5) {
          sum += parseFloat(array[i].payment_giro)
        }
      }
      return sum
    },
    totalPaymentCashBankKomisiIn15 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1.5) {
          sum += parseFloat(array[i].payment_cash_bank)
        }
      }
      return sum
    },
    totalPaymentKomisiIn15 () {
      var sum = 0
      sum = this.totalPaymentGiroKomisiIn15 + this.totalPaymentCashBankKomisiIn15 - this.totalDiscount15 + this.totalRound15
      return sum
    },
    totalKomisiIn15 () {
      var sum = 0
      var array = this.dataKomisiIn15
      for (let i = 0; i < array.length; i++) {
        sum += array[i].commission_amount
      }
      return sum
    },
    dataKomisiIn15 () {
      var array = this.dataKomisiPayment
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1.5) {
          var obj = {
            id: array[i].id,
            sale_no: array[i].sale_no,
            payment_no: array[i].payment_no,
            payment_date: array[i].payment_date,
            sale_date: array[i].sale_date,
            age: array[i].age,
            payment_giro: array[i].payment_giro,
            payment_cash_bank: array[i].payment_cash_bank,
            payment_amount: array[i].payment_amount,
            commission_id: array[i].commission_id,
            commission_percentage: array[i].commission_percentage,
            commission_amount: array[i].commission_amount,
            commission_type: array[i].commission_type,
            customer_no: array[i].customer_no,
            customer: array[i].customer,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            status: array[i].status
          }
          loop.push(obj)
        }
      }
      return loop
    },
    // Komisi 1 %
    dataKomisiIn1 () {
      var array = this.dataKomisiPayment
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1) {
          var obj = {
            id: array[i].id,
            sale_no: array[i].sale_no,
            payment_no: array[i].payment_no,
            payment_date: array[i].payment_date,
            sale_date: array[i].sale_date,
            age: array[i].age,
            payment_giro: array[i].payment_giro,
            payment_cash_bank: array[i].payment_cash_bank,
            payment_amount: array[i].payment_amount,
            commission_id: array[i].commission_id,
            commission_percentage: array[i].commission_percentage,
            commission_amount: array[i].commission_amount,
            commission_type: array[i].commission_type,
            customer_no: array[i].customer_no,
            customer: array[i].customer,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            status: array[i].status
          }
          loop.push(obj)
        }
      }
      return loop
    },
    // Komisi 0.5%
    dataKomisiIn05 () {
      var array = this.dataKomisiPayment
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 0.5) {
          var obj = {
            id: array[i].id,
            sale_no: array[i].sale_no,
            payment_no: array[i].payment_no,
            payment_date: array[i].payment_date,
            sale_date: array[i].sale_date,
            age: array[i].age,
            payment_giro: array[i].payment_giro,
            payment_cash_bank: array[i].payment_cash_bank,
            payment_amount: array[i].payment_amount,
            commission_id: array[i].commission_id,
            commission_percentage: array[i].commission_percentage,
            commission_amount: array[i].commission_amount,
            commission_type: array[i].commission_type,
            customer_no: array[i].customer_no,
            customer: array[i].customer,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            status: array[i].status
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalPaymentGiroKomisiIn1 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1) {
          sum += parseFloat(array[i].payment_giro)
        }
      }
      return sum
    },
    totalPaymentGiroKomisiIn05 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (Number(parseFloat(array[i].commission_percentage)) === 0.5) {
          sum += parseFloat(array[i].payment_giro)
        }
      }
      return sum
    },
    totalPaymentCashBankKomisiIn1 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 1) {
          sum += parseFloat(array[i].payment_cash_bank)
        }
      }
      return sum
    },
    totalPaymentCashBankKomisiIn05 () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].commission_percentage) === 0.5) {
          sum += parseFloat(array[i].payment_cash_bank)
        }
      }
      return sum
    },
    totalPaymentKomisiIn1 () {
      var sum = 0
      sum = this.totalPaymentGiroKomisiIn1 + this.totalPaymentCashBankKomisiIn1 - this.totalDiscount1 + this.totalRound1
      return sum
    },
    totalPaymentKomisiIn05 () {
      var sum = 0
      sum = this.totalPaymentGiroKomisiIn05 + this.totalPaymentCashBankKomisiIn05 - this.totalDiscount05 + this.totalRound05
      return sum
    },
    totalKomisiIn1 () {
      var sum = 0
      var array = this.dataKomisiIn1
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].commission_amount)
      }
      return sum
    },
    // Komisi Out
    dataKomisiOut () {
      var array = this.dataKomisiPayment
      var loop = []
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          var obj = {
            id: array[i].id,
            sale_no: array[i].sale_no,
            payment_no: array[i].payment_no,
            payment_date: array[i].payment_date,
            sale_date: array[i].sale_date,
            age: array[i].age,
            payment_giro: array[i].payment_giro,
            payment_cash_bank: array[i].payment_cash_bank,
            payment_amount: array[i].payment_amount,
            commission_id: array[i].commission_id,
            commission_percentage: array[i].commission_percentage,
            commission_amount: array[i].commission_amount,
            commission_type: array[i].commission_type,
            customer_no: array[i].customer_no,
            customer: array[i].customer,
            salesman_id: array[i].salesman_id,
            salesman: array[i].salesman,
            status: array[i].status
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalPaymentGiroKomisiOut () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          sum += parseFloat(array[i].payment_giro)
        }
      }
      return sum
    },
    totalPaymentCashBankKomisiOut () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          sum += parseFloat(array[i].payment_cash_bank)
        }
      }
      return sum
    },
    totalPaymentKomisiOut () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          sum += parseFloat(array[i].payment_amount)
        }
      }
      return sum
    },
    totalKomisiOut () {
      var sum = 0
      var array = this.dataKomisiPayment
      for (let i = 0; i < array.length; i++) {
        if (array[i].status === 'out') {
          sum += parseFloat(array[i].commission_amount)
        }
      }
      return sum
    },
    totalKomisi () {
      var sum = 0
      sum = Math.round(parseFloat(this.totalKomisiDiscount1 + this.totalKomisiDiscount15 + this.totalKomisiDiscount05 + this.totalKomisiSupervisorIn) + parseFloat(this.komisiPlus) - parseFloat(this.dataTotalPenalty))
      return sum
    },
    totalKomisiPembulatan () {
      var amount = String(this.totalKomisi)
      const selisih = parseFloat(amount.substring(amount.length - 4))
      var result = 0
      if (selisih < 5000) {
        result = parseFloat(amount) - selisih
      } else {
        result = parseFloat(amount) + (10000 - selisih)
      }
      return result
    },
    komisiOnePercent () {
      var array = this.dataKomisi
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let z = 0; z < sales.length; z++) {
          if (parseFloat(sales[z].sale_commission_percentage) === 1) {
            sum += parseFloat(sales[z].sale_commission_amount)
          }
        }
      }
      return sum
    },
    komisiOneHalfPercent () {
      var array = this.dataKomisi
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        var sales = array[i].sales
        for (let z = 0; z < sales.length; z++) {
          if (parseFloat(sales[z].sale_commission_percentage) === 1.5) {
            sum += parseFloat(sales[z].sale_commission_amount)
          }
        }
      }
      return sum
    },
    totalOmzet () {
      var sum = 0
      var array = this.dataSales
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].total_sales) > 0) {
          sum += parseFloat(array[i].total_sales)
        }
      }
      return sum
    },
    totalOmzetPPN () {
      var sum = 0
      var array = this.dataSales
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].total_sales) > 0) {
          sum += parseFloat(array[i].total_sales_ppn)
        }
      }
      return sum
    },
    totalOmzetNonPPN () {
      var sum = 0
      var array = this.dataSales
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].total_sales) > 0) {
          sum += parseFloat(array[i].total_sales_non_ppn)
        }
      }
      return sum
    },
    omzetData () {
      var loop = []
      var array = this.dataSales
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].total_sales) > 0) {
          var obj = {
            id: array[i].id,
            name: array[i].name,
            totalSales: array[i].total_sales,
            totalSalesPPN: array[i].total_sales_ppn,
            totalSalesNonPPN: array[i].total_sales_non_ppn
          }
          loop.push(obj)
        }
      }
      return loop
    },
    totalCOGS () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'retur') {
            sum -= parseFloat(arr[b].total)
          } else {
            sum += parseFloat(arr[b].total)
          }
        }
      }
      return sum
    },
    totalSales () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'sales') {
            sum += parseFloat(arr[b].total)
          }
        }
      }
      return sum
    },
    totalRetur () {
      var sum = 0
      var array = this.dataRaw
      for (let i = 0; i < array.length; i++) {
        var arr = array[i].data
        for (let b = 0; b < arr.length; b++) {
          if (arr[b].type === 'retur') {
            sum += parseFloat(arr[b].total)
          }
        }
      }
      return sum
    },
    salesRaw () {
      var array = this.dataRaw
      var loop = []
      for (let i = 0; i < array.length; i++) {
        var data = array[i].data
        for (let b = 0; b < data.length; b++) {
          loop.push(data[b])
        }
      }
      return loop
    },
    groupSales () {
      var result = []
      if (this.salesRaw.length > 0) {
        this.salesRaw.reduce(function (res, value) {
          // key = Date.parse(value.cost_date) + value.queue + value.company_no
          var key = value.ref_no
          if (!res[key]) {
            res[key] = {
              ref_no: value.ref_no,
              total: parseFloat(value.total)
            }
            result.push(res[key])
          } else {
            res[key].total = parseFloat(res[key].total) + parseFloat(value.total)
          }
          return res
        }, {})
      }
      var col = 'ref_no'
      var ascending = true
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return result.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    lossSummary () {
      var array = this.groupSummary
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].total_margin < 0) {
          sum += parseFloat(array[i].total_margin)
        }
      }
      return sum
    },
    profitSummary () {
      var array = this.groupSummary
      var sum = 0
      for (let i = 0; i < array.length; i++) {
        if (array[i].total_margin > 0) {
          sum += parseFloat(array[i].total_margin)
        }
      }
      return sum
    },
    groupSummary () {
      var loop = []
      var array = this.dataRaw
      for (let a = 0; a < array.length; a++) {
        var groupData = array[a].groupData
        for (let b = 0; b < groupData.length; b++) {
          loop.push(groupData[b])
        }
      }
      var col = 'total_margin'
      var ascending = false
      // eslint-disable-next-line vue/no-side-effects-in-computed-properties
      return loop.sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      })
    },
    totalIncome () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type === 'income')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalOutcome () {
      var sum = 0
      var array = this.dataRaw.filter(d => d.type === 'outcome')
      for (let i = 0; i < array.length; i++) {
        sum += parseFloat(array[i].total)
      }
      return sum
    },
    totalTransfer () {
      var sum = 0
      return sum
    },
    getUserSalesman: function () {
      var array = this.employeeList.filter(e => e.position_id === 'H4.1' || e.position_id === 'H4.2' || e.position_id === 'H1' || e.position_id === 'H2')
      var loop = [{
        salesman: '-- All --',
        meta: {
          code: ''
        }
      }]
      for (let a = 0; a < array.length; a++) {
        var obj = {
          salesman: '[' + array[a].employee_no + '] ' + array[a].name,
          meta: {
            code: array[a].employee_no
          }
        }
        loop.push(obj)
      }
      return loop
    },
    pageLength: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      var length = count / this.pageSize

      return Math.ceil(length)
    },
    rowsTotal: function () {
      var count = 0
      if (this.searchQuery.length < 0 || this.searchQuery === null) {
        count = this.dataRaw.length
      } else {
        count = this.dataRaw
          .filter(d => {
            for (const name in d) {
              if (d[name] !== null) {
                if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
                  return d
                }
              }
            }
          }).length
      }
      // console.log(count)
      return count
    },
    filterData: function () {
      var col = this.sortColumn
      var ascending = this.ascending
      return this.dataRaw.slice().sort(function (a, b) {
        if (a[col] > b[col]) {
          return ascending ? 1 : -1
        } else if (a[col] < b[col]) {
          return ascending ? -1 : 1
        }
        return 0
      }).filter(d => {
        for (const name in d) {
          if (d[name] !== null) {
            if (d[name].toString().toLowerCase().indexOf(this.searchQuery.toLowerCase()) > -1) {
              return d
            }
          }
        }
      }).filter(d => {
        if (this.filterType.length > 0) {
          for (let i = 0; i < this.filterType.length; i++) {
            if (this.filterType[i] === d.type) {
              return d
            }
          }
        } else {
          return d
        }
      }).filter((row, index) => {
        const start = (this.currentPage - 1) * this.pageSize
        const end = this.currentPage * this.pageSize
        if (index >= start && index < end) return true
      })
    }
  },
  methods: {
    async lockKomisi () {
      const array = this.dataKomisiSupervisorPayment
      for (let i = 0; i < array.length; i++) {
        await axios.post(salesUrl + '/payment/lock', { id: array[i].id }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Commission Supervisor Lock', error.response.data.message, 'error')
            throw error
          })
      }
      const arr = this.dataKomisiPayment
      for (let i = 0; i < arr.length; i++) {
        await axios.post(salesUrl + '/payment/lock', { id: arr[i].id }, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Commission Lock', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$swal('Commission Lock', 'Success lock Sale Commission', 'success')
    },
    async getKomisiAllCompany () {
      const endDate = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var array = this.groupDataSales
      for (let i = 0; i < array.length; i++) {
        var body = {
          amount: array[i].total,
          employee_no: this.salesman_id,
          date: endDate
        }
        console.log(body)
        await axios.post(saleCommissionUrl + '/get-omzet', body, { headers: getHeader() })
          .then(response => {
            this.komisiPlus += response.data.data.fee
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async getSalemanByMonthly () {
      if (this.salesman_id === '' || this.salesman_id === null) {
        console.log(this.salesman_id)
      } else {
        const year = this.startDate[1].getFullYear()
        var obj = {
          year: year,
          company: this.company_no,
          salesman_id: this.salesman_id
        }
        console.log(obj)
        console.log(reportUrl + '/salesman-sales-by-monthly')
        await axios.post(reportUrl + '/salesman-sales-by-monthly', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
            var data = []
            var data2 = []
            var data3 = []
            var array = response.data.data
            for (let i = 0; i < array.length; i++) {
              data.push(array[i].total_sales)
              data2.push(array[i].total_return)
              data3.push(array[i].total)
            }
            console.log(response.data.label)
            console.log(data)
            this.option = {
              title: {
                text: 'Salesman By Monthly',
                left: 'left'
              },
              legend: {},
              tooltip: {
                trigger: 'axis'
              },
              xAxis: {
                type: 'category',
                data: response.data.label
              },
              yAxis: {
                type: 'value'
              },
              series: [{
                data: data3,
                type: 'bar',
                name: 'Total',
                itemStyle: { color: '#4EA397' },
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(180, 180, 180, 0.2)'
                }
              }, {
                data: data,
                type: 'bar',
                name: 'Omzet',
                itemStyle: { color: '#22C3AA' },
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(180, 180, 180, 0.2)'
                }
              }, {
                data: data2,
                type: 'bar',
                name: 'Retur',
                itemStyle: { color: '#7BD9A5' },
                showBackground: true,
                backgroundStyle: {
                  color: 'rgba(180, 180, 180, 0.2)'
                }
              }]
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    async refreshAll () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.getSales()
      await this.getKomisi()
      await this.getKomisiSupervisor()
      await this.getRetur()
      await this.getKomisiPayment()
      await this.getSalemanByMonthly()
      await this.getKomisiSupervisorPayment()
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async refreshAll2 () {
      await this.$Progress.start()
      this.loader.isLoading = true
      await this.getSales()
      await this.getKomisi()
      await this.getKomisiSupervisor()
      await this.getRetur()
      await this.getKomisiPayment2()
      await this.getSalemanByMonthly()
      await this.getKomisiSupervisorPayment()
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async getRetur () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      console.log(obj)
      await axios.post(salesUrl + '/report-retur-salesman', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRetur = response.data.data
          this.dataTotalRetur = response.data.total_retur
          this.dataTotalPenalty = response.data.total_penalty
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisi () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      await axios.post(salesUrl + '/report-komisi-salesman', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisi = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisiSupervisor () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      await axios.post(salesUrl + '/report-komisi-supervisor', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisiSupervisor = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisiSupervisor2 () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      await axios.post(salesUrl + '/report-komisi-supervisor', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisiSupervisor = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisiPayment () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-komisi-salesman-payment')
      await axios.post(salesUrl + '/report-komisi-salesman-payment', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisiPayment = response.data.data
          this.groupPayment = response.data.groupPayment
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisiPayment2 () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-komisi-salesman-payment-2')
      await axios.post(salesUrl + '/report-komisi-salesman-payment-2', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisiPayment = response.data.data
          this.groupPayment = response.data.groupPayment
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getKomisiSupervisorPayment () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-komisi-supervisor-payment')
      await axios.post(salesUrl + '/report-komisi-supervisor-payment', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataKomisiSupervisorPayment = response.data.data
          this.groupSupervisorPayment = response.data.groupPayment
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
    },
    async getSales () {
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        salesman_id: this.salesman_id,
        company_no: null
      }
      await axios.post(salesUrl + '/report-sales-salesman', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataSales = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      var amount = 0
      var array = this.dataSales
      for (let i = 0; i < array.length; i++) {
        if (parseFloat(array[i].total_sales) > 0) {
          amount += parseFloat(array[i].total_sales)
        }
      }
      if (this.company_no === null || this.company_no === '') {
        await this.getKomisiAllCompany()
      } else {
        var body = {
          amount: amount,
          employee_no: this.salesman_id,
          date: end
        }
        await axios.post(saleCommissionUrl + '/get-omzet', body, { headers: getHeader() })
          .then(response => {
            console.log(body)
            console.log(response.data.message)
            console.log(response.data.data)
            if (this.company_no !== 'C0001') {
              this.komisiPlus = response.data.data.fee
            } else {
              this.komisiPlus = 0
            }
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
          })
      }
    },
    async uncheckReportPayment (id, refNo) {
      var array = this.selected
      var status = false
      for (let i = 0; i < array.length; i++) {
        if (array[i] === id) {
          status = true
        } else {
          status = false
        }
      }
      if (status === false) {
        var obj = {
          payment_no: refNo
        }
        await axios.post(reportTransactionUrl + '/remove-report-payment', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
    },
    showSaleNo (no) {
      var payload = {
        sale_no: no
      }
      // this.$store.commit('SET_SALE_BY_NO', payload)
      this.$store.dispatch('getSaleByNo', payload)
    },
    setPageSizeOnChange: function () {
      this.currentPage = 1
    },
    sortTable: function sortTable (col) {
      this.currentPage = 1
      if (this.sortColumn === col) {
        this.ascending = !this.ascending
      } else {
        this.ascending = true
        this.sortColumn = col
      }
    },
    nextPage: function () {
      if ((this.currentPage * this.pageSize) < this.rowsTotal) this.currentPage++
    },
    prevPage: function () {
      if (this.currentPage > 1) this.currentPage--
    },
    select () {
      this.selected = []
      //   this.currentPage = 1
      if (!this.selectAll) {
        for (const i in this.filterData) {
          this.selected.push(this.filterData[i].id)
        }
      }
    },
    async refreshList () {
      this.$Progress.start()
      this.loader.isLoading = true
      this.selected = []
      const begin = this.startDate[0] ? this.startDate[0].getFullYear() + '-' + (this.startDate[0].getMonth() + 1) + '-' + this.startDate[0].getDate() : null
      const end = this.startDate[1] ? this.startDate[1].getFullYear() + '-' + (this.startDate[1].getMonth() + 1) + '-' + this.startDate[1].getDate() : null
      var obj = {
        begin: begin,
        end: end,
        company_no: this.company_no
      }
      console.log(obj)
      console.log(salesUrl + '/report-laba-sales-by-product')
      await axios.post(salesUrl + '/report-laba-sales-by-product', obj, { headers: getHeader() })
        .then(response => {
          console.log(response.data.message)
          this.dataRaw = response.data.data
        })
        .catch(error => {
          console.log(error)
          console.log(error.response)
          this.$swal('Error', error.response.data.message, 'error')
          throw error
        })
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async processReport () {
      this.$Progress.start()
      this.loader.isLoading = true
      for (let c = 0; c < this.selected.length; c++) {
        var data = this.dataRaw.find(d => d.id === this.selected[c])
        var obj = {
          cash_id: data.id,
          company_no: data.company_no,
          report_date: data.cash_date
        }
        await axios.post(reportTransactionUrl + '/create-cash-on-hand', obj, { headers: getHeader() })
          .then(response => {
            console.log(response.data.message)
          })
          .catch(error => {
            console.log(error)
            console.log(error.response)
            this.$swal('Error', error.response.data.message, 'error')
            throw error
          })
      }
      await this.$Progress.finish()
      this.loader.isLoading = false
    },
    async print (type) {
      this.$Progress.start()
      this.loader.isLoading = true
      var data = {
        salesman: this.salesman_id,
        company: this.company_no,
        format: type,
        data: this.dataRetur,
        omzet: this.omzetData,
        totalOmzet: this.totalOmzet,
        totalOmzetPPN: this.totalOmzetPPN,
        totalOmzetNonPPN: this.totalOmzetNonPPN,
        totalPaymentCashBank: this.totalPaymentCashBank,
        totalPaymentGiro: this.totalPaymentGiro,
        totalPaymentAll: this.totalPaymentAll,
        totalKomisiDiscount1: this.totalKomisiDiscount1,
        totalKomisiDiscount15: this.totalKomisiDiscount15,
        totalKomisiDiscount05: this.totalKomisiDiscount05,
        totalRetur: this.dataTotalRetur,
        totalPenalty: this.dataTotalPenalty,
        komisiAcc: this.totalKomisiIn15 + this.totalKomisiIn1 + this.totalKomisiIn05,
        komisiPlus: this.komisiPlus,
        dataTotalPenalty: this.dataTotalPenalty,
        totalKomisi: this.totalKomisi,
        totalKomisiPembulatan: this.totalKomisiPembulatan,
        // 15
        dataKomisiIn15: this.dataKomisiIn15,
        totalPaymentCashBankKomisiIn15: this.totalPaymentCashBankKomisiIn15,
        totalPaymentGiroKomisiIn15: this.totalPaymentGiroKomisiIn15,
        totalRound15: this.totalRound15,
        totalDiscount15: this.totalDiscount15,
        totalPaymentKomisiIn15: this.totalPaymentKomisiIn15,
        totalKomisiIn15: this.totalKomisiIn15,
        // 1
        dataKomisiIn1: this.dataKomisiIn1,
        totalPaymentCashBankKomisiIn1: this.totalPaymentCashBankKomisiIn1,
        totalPaymentGiroKomisiIn1: this.totalPaymentGiroKomisiIn1,
        totalRound1: this.totalRound1,
        totalDiscount1: this.totalDiscount1,
        totalPaymentKomisiIn1: this.totalPaymentKomisiIn1,
        totalKomisiIn1: this.totalKomisiIn1,
        // 0.5
        dataKomisiIn05: this.dataKomisiIn05,
        totalPaymentCashBankKomisiIn05: this.totalPaymentCashBankKomisiIn05,
        totalPaymentGiroKomisiIn05: this.totalPaymentGiroKomisiIn05,
        totalRound05: this.totalRound05,
        totalDiscount05: this.totalDiscount05,
        totalPaymentKomisiIn05: this.totalPaymentKomisiIn05,
        totalKomisiIn05: this.totalKomisiIn05,
        // etc
        dataKomisiOut: this.dataKomisiOut,
        totalPaymentCashBankKomisiOut: this.totalPaymentCashBankKomisiOut,
        totalPaymentGiroKomisiOut: this.totalPaymentGiroKomisiOut,
        totalPaymentKomisiOut: this.totalPaymentKomisiOut
      }
      console.log(data)
      if (data.length === 0) {
        this.$swal('Error', 'Data masih kosong', 'error')
        return false
      }
      await axios.post(report2Url + '/salesman', data, { responseType: 'blob' })
        .then(response => {
          const objectUrl = URL.createObjectURL(response.data)
          console.log('Showing PDF...')
          window.open(objectUrl, '_blank')
          this.$Progress.finish()
          this.loader.isLoading = false
        })
        .catch(error => {
          this.$Progress.finish()
          this.loader.isLoading = false
          console.log(error)
          console.log(error.response)
        })
    }
  }
}
</script>

<style scoped>
.header-period {
    background-color: #6FB56F;
    color: white;
}
.text-ref-sales {
    color: #28A745;
    cursor: pointer;
}
</style>
